<template>
  <div class="avr-card p-0 shadow">
    <div class="p-4">
      <slot name="header"></slot>
      <div class="dropdown-section" :class="{ 'is-open': isOpen }">
        <slot name="dropdown"></slot>
      </div>
    </div>
    <div @click="isOpen = !isOpen" :class="{ 'd-sm-none': !togglesOnDesktop }" class="pl-4 pr-5 py-3 show-hide">
      <slot v-if="isOpen" name="hideLabel"></slot>
      <slot v-else name="showLabel"></slot>
      <img class="chevron" :class="{ 'is-open': isOpen }" src="@/assets/fa/chevron-down.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDownCard',
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    isOpenDefaultMobile: {
      type: Boolean,
      default: false,
    },
    isOpenDefaultDesktop: {
      type: Boolean,
      default: false,
    },
    togglesOnDesktop: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    window.addEventListener('resize', this.checkScreenSize);
    this.checkScreenSize();
  },
  destroyed() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      if (window.innerWidth > 575) {
        this.isOpen = this.isOpenDefaultDesktop || !this.togglesOnDesktop;
      } else {
        this.isOpen = this.isOpenDefaultMobile;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.avr-card {
  overflow: hidden;
}
.dropdown-section {
  transition: all 0.5s ease;
  opacity: 0;
  max-height: 0;
  &.is-open {
    opacity: 1;
    max-height: 1000px;
  }
}
.show-hide {
  position: relative;
  background-color: #ffffff;
  cursor: pointer;
  border-top: 1px solid #dae2ea;
  img {
    position: absolute;
    display: block;
    width: 24px;
    height: 15px;
    right: 15px;
    top: 50%;
    margin-top: -8px;
    transition: all 0.4s ease;
    &.is-open {
      transform: rotate(-180deg);
    }
  }
}
</style>
